import * as components from './components'
import * as hooks from './hooks'

console.log('Custom gateway artwork feature initialized!')

export { components, hooks }
